// Number of entries to return for the operatorRetrieve verb
export enum ChatCount
{
  MAX_CONTACTS = 20,
  MIN_MSGS = 20,
  MAX_MSGS = 1000,
  OLDER_MSGS = 10
}
